<template>
    <x-ajax-dropdown
        :allowEmpty="allowEmpty"
        :blacklist="blacklist"
        :customLabel="(option) => `${option.name}`"
        :disabled="isLoading"
        :multiple="true"
        :placeholder="placeholder"
        :query="query"
        :url="`/api/users`"
        :value="selectedResources"
        @input="handleInput"
        class="form-control"
    />
</template>

<script>
import axios from "axios";
import { get } from "lodash";
import { deepCopy, emptyPromise, handleGeneralXhrError } from "../helpers";
import XAjaxDropdown from "./XAjaxDropdown.vue";

export default {
    components: { XAjaxDropdown },
    created() {
        this.initSelectedResources();
    },
    data() {
        return {
            isLoading: false,
            selectedResources: [],
        };
    },
    methods: {
        fetchSelectedResources() {
            if (this.valueIsEmpty()) {
                this.selectedResources = [];
                return emptyPromise();
            }
            this.isLoading = true;
            const request = axios
                .get(`/api/users`, {
                    params: {
                        ids: this.value.map((id) => id),
                    },
                })
                .then((response) => {
                    this.selectedResources = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleInput(resources) {
            this.selectedResources = resources;
            if (this.valueIsEmpty()) {
                this.$emit(
                    "input",
                    resources.map((resource) => this.defaultParser(resource))
                );
                return;
            }
            const output = this.valueIsObject()
                ? resources
                : resources.map((resource) => this.defaultParser(resource));

            this.$emit("input", output);
        },
        initSelectedResources() {
            if (!this.valueIsEmpty() && !this.valueIsObject()) {
                this.fetchSelectedResources();
                return;
            }
            this.selectedResources = deepCopy(this.value);
        },
        valueIsEmpty() {
            return this.value.length <= 0;
        },
        valueIsObject() {
            return typeof get(this, "value.0") === "object";
        },
    },
    props: {
        allowEmpty: {
            type: Boolean,
            required: false,
            default: true,
        },
        blacklist: {
            type: Array,
            required: false,
            default: () => [],
        },
        defaultParser: {
            type: Function,
            required: false,
            default: (data) => data,
        },
        placeholder: {
            type: String,
            required: false,
            default: "Pilih User",
        },
        query: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        value: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    watch: {
        value: {
            handler() {
                this.initSelectedResources();
            },
            deep: true,
        },
    },
};
</script>
